<template>
  <div class="center">{{ $t("no_item_yet") }}</div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
  .center {
    @apply flex justify-center items-center h-210;
  }
</style>
